/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 基本设置
  Arrive: () => import(/* webpackChunkName: "dict" */ '@/views/page/News/Arrive/index'), // 上架新闻
  Library: () => import(/* webpackChunkName: "dict" */ '@/views/page/News/Library/index'), // 新闻库
};

export const newsRoute = [
  {
    path: '/News',
    component: Layout,
    isMenu: true,
    name: 'News',
    redirect: { name: 'Arrive' },
    meta: { title: '新闻中心', icon: 'menu_xinwen' },
    children: [
      {
        path: 'Arrive',
        name: 'Arrive',
        component: routes['Arrive'],
        meta: { title: '上架新闻管理'}
      },
      {
        path: 'Library',
        name: 'Library',
        component: routes['Library'],
        meta: { title: '新闻库'}
      }
    ]
  }
];
